<script lang="ts">import { goto } from "$app/navigation";
import { isRewardPromo, isRewardPromoClaimReady } from "../utils";
import { FeatureSet, stateFeatureSet, stateUi } from "@infinitro/config";
import { isAbsoluteHttpUrl, isMobile, loggedIn, ModalDialog, refreshVipState, stateOpenModal, stateVipState, toSiteUrl } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { get } from "svelte/store";
import PromoItemContentCustom from "./promo-item/promo-item-content-custom.svelte";
import PromoItemContent from "./promo-item/promo-item-content.svelte";
export let promo;
export let highlight;
export let isNew;
export let isDetail;
let active = false;
$: useLoggedInPromoCta = $loggedIn === true || ($stateUi.promotions?.promoCtasMatchLoggedInWhenLoggedOut ?? false);
const checkActive = (p, featureSet) => {
	const now = Date.now();
	const start = p?.startDate ? p.startDate.getTime() : null;
	const end = p?.endDate ? p.endDate.getTime() : null;
	active = !!(!start && !end || start && !end && now >= start || !start && end && now <= end || start && end && now >= start && now <= end || featureSet === FeatureSet.Preview);
};
const resolveUrl = () => {
	if (promo.conditionalUrl) {
		return $loggedIn === true ? promo.conditionalUrl.loggedInUrl : promo.conditionalUrl.loggedOutUrl;
	}
	return promo.url;
};
const getPromoLink = () => {
	if (promo.useUrlForDetail) {
		const resolvedUrl = resolveUrl();
		const toSiteIsLoggedIn = promo.conditionalUrl ? $loggedIn === true : useLoggedInPromoCta;
		return isAbsoluteHttpUrl(resolvedUrl) ? resolvedUrl : toSiteUrl(resolvedUrl, toSiteIsLoggedIn);
	}
	if (promo.isFlushRace) {
		return toSiteUrl(promo.url ? promo.url : `/promotion-page/race/${promo.id}`, useLoggedInPromoCta);
	}
	return toSiteUrl(`/promotion-page/${promo.id}`, useLoggedInPromoCta);
};
$: checkActive(promo, $stateFeatureSet);
$: useAlternative = $stateUi.promotions.promotionsStyle === "alternative";
$: customGridPromoHref = getPromoLink();
$: customGridPromoHrefExternal = isAbsoluteHttpUrl(customGridPromoHref);
const getRewardFallbackUrl = () => toSiteUrl($loggedIn === true ? "/vip-dashboard/" : "/vip/", $loggedIn === true);
const handleRewardPromoCardClick = async (event) => {
	if (!isRewardPromo(promo) || !active) return;
	event.preventDefault();
	event.stopPropagation();
	if ($loggedIn !== true) {
		goto(getRewardFallbackUrl());
		return;
	}
	const vipStateSnapshot = get(stateVipState);
	if (Array.isArray(vipStateSnapshot?.rewards)) {
		if (isRewardPromoClaimReady(promo, vipStateSnapshot)) {
			stateOpenModal.set(ModalDialog.RewardsDropdown);
			return;
		}
		goto(getRewardFallbackUrl());
		return;
	}
	await refreshVipState();
	const refreshedVipState = get(stateVipState);
	if (isRewardPromoClaimReady(promo, refreshedVipState)) {
		stateOpenModal.set(ModalDialog.RewardsDropdown);
		return;
	}
	goto(getRewardFallbackUrl());
};
</script>

<InfoCard
	noPadding={true}
	{highlight}
	borderRadius={useAlternative
		? '8px'
		: isDetail && !$isMobile
			? '36px'
			: $isMobile
				? '22px'
				: '28px'}
>
	<div
		class="promo-item-custom"
		class:variant-aspect-ratio-box={useAlternative && !$isMobile}
		class:variant-aspect-ratio-box-mobile={useAlternative && $isMobile}
		class:variant-aspect-ratio-box-detail={useAlternative && isDetail && !$isMobile}
		class:variant-aspect-ratio-box-detail-alternative={useAlternative &&
			isDetail &&
			!$isMobile &&
			$stateUi.promotions.useAspectRatioBoxDetailCustom}
		class:variant-aspect-ratio-box-detail-mobile={useAlternative && isDetail && $isMobile}
	>
		{#if isDetail}
			{#if $stateUi.layout.usePromoItemContentCustom}
				<PromoItemContentCustom {promo} {active} {isNew} {isDetail} custom={true} />
			{:else}
				<PromoItemContent {promo} {active} {isNew} {isDetail} custom={true} />
			{/if}
		{:else}
			<a
				href={customGridPromoHref}
				target={customGridPromoHrefExternal ? '_blank' : undefined}
				rel={customGridPromoHrefExternal ? 'noopener noreferrer' : undefined}
				on:click={handleRewardPromoCardClick}
			>
				{#if $stateUi.layout.usePromoItemContentCustom}
					<PromoItemContentCustom {promo} {active} {isNew} {isDetail} custom={true} />
				{:else}
					<PromoItemContent {promo} {active} {isNew} {isDetail} custom={true} />
				{/if}
			</a>
		{/if}
	</div>
</InfoCard>

<style>
	.promo-item-custom {
		max-height: 400px;
	}
	.variant-aspect-ratio-box {
		position: relative;
		width: 100%;
		padding-bottom: calc(0.62 / 1 * 100%);
	}

	.variant-aspect-ratio-box-mobile {
		position: relative;
		width: 100%;
		padding-bottom: calc(0.58 / 1 * 100%);
	}

	.variant-aspect-ratio-box-detail {
		padding-bottom: calc(0.3 / 1 * 100%);
	}

	.variant-aspect-ratio-box-detail-alternative {
		padding-bottom: calc(0.3 / 1 * 100% + 40px);
	}

	.variant-aspect-ratio-box-detail-mobile {
		padding-bottom: calc(0.58 / 1 * 100%);
	}

	@media (min-width: 768px) {
		.variant-aspect-ratio-box-detail-mobile {
			padding-bottom: calc(0.47 / 1 * 100%);
		}
	}
</style>
